module.exports = __webpack_public_path__ + "img/bird-9-left.cd2ee825.png";